import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { serializeSortItem } from '@utils/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-accounts/')({
  validateSearch: zodValidator(withDefaults(schema.ALL_ACCOUNTS, { orderBy: [serializeSortItem({ property: 'name', isAsc: true })] })),
});
